import { FilterModel } from 'common/data/filter/model';

export const filterSettingsAdditional = [
  { jsonApiType: 'page_limit', id: 'page_limit' },
  { jsonApiType: 'page_number', id: 'page_number' },
  { jsonApiType: 'keyword', id: 'keyword' },
] as FilterModel[];
